import { UserStatus, UserType } from "../../constants/CalendarEnums";

export const PER_PAGE_CLINICIAN = 7;

export const INITIAL_HOLDS_PAYLOAD = {
  start_date: new Date().toISOString()
            .replace(/T(\d{2}:\d{2}:\d{2})/, "T00:00:00"),
  for_days: 7,
  service_type: '',
  meeting_pref: [],
  therapist_ids: [],
  therapist_names: [],
};

export const INITIAL_USER_SEARCH_PARAM = {
  limit: PER_PAGE_CLINICIAN,
  user_type: UserType.Therapist,
  offset: 0,
  sort_by: 'fullName:asc',
  user_status: UserStatus.SuccessfulOnboarding,
};

export const weekDays: string[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export type WorkingHour = {
  day_of_week: string;
  start_time: string;
  end_time: string;
  is_working_day: boolean;
  timezone: string;
}

export type ProviderWorkingHours = {
  provider_id: string;
  working_hours: WorkingHour[];
}